import { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaResult from '../../../../components/AccionaResult';
import { MainContext } from '../../../../context/MainContext';
import { updateProjectTemplate } from '../../../../services/api/projectTemplates';
import { useNavigate, useOutletContext } from 'react-router-dom';

const SuccessUpdatePage = ({ customFinishButton, loadedTemplate, regions }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();
  const { setLoading } = useContext(MainContext);

  //TODO: Props cannot be modified. Never!
  const customUpdateButton = async () => {
    loadedTemplate.regions = regions;
    loadedTemplate.searchableRegion.value = '';
    setLoading(true);
    await updateProjectTemplate(loadedTemplate);
    setLoading(false);
    navigate(`/app/project/${project.id_project}/quality/ocr`, {
      replace: true,
    });
  };

  return (
    <AccionaResult
      id="succesResult"
      icon={
        <i className="fas fa-check-circle fa-8x" style={{ color: '#82c91e' }} />
      }
      title={intl.formatMessage({ id: 'template.update' })}
      className="success"
      extra={[
        <div key="1" style={{ marginTop: '24px' }}>
          <div key="extraSuccess1" className="form-row">
            <AccionaButton
              id="successBtn"
              onClick={() => navigate(customFinishButton(), { replace: true })}
              msg={intl.formatMessage({ id: 'button.create.end' })}
            />
            <AccionaButton
              id="updateBtn"
              onClick={() => customUpdateButton()}
              msg={intl.formatMessage({ id: 'button.update.end' })}
            />
          </div>
        </div>,
      ]}
    />
  );
};

SuccessUpdatePage.propTypes = {
  customFinishButton: PropTypes.element,
  loadedTemplate: PropTypes.object,
  regions: PropTypes.arrayOf(PropTypes.object),
};

SuccessUpdatePage.defaultProps = {
  customFinishButton: undefined,
  loadedTemplate: {},
  regions: [],
};

export default SuccessUpdatePage;
